import React from 'react';

import Avatar from '../../../../components/helper/avatar';

const OKRHeaderProfile = ({ goalOwnerPic }: any) => (
    <div className="header_profile_section">
        <Avatar src={goalOwnerPic} imageClass="okr-owner-profile" useSpriteSheet={false} />
    </div>
)

export default OKRHeaderProfile;
